import Forbidder from '@/views/403'
import NotFound from '@/views/404'
import ServerErr from '@/views/500'

export default [
  {
    path: '/login',
    name: 'Login',
    hideInMenu: true,
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue')
  },
  {
    path: '/403',
    name: '403',
    hideInMenu: true,
    component: Forbidder
  },
  {
    path: '/500',
    name: '500',
    hideInMenu: true,
    component: ServerErr
  },
  {
    path: '/404',
    name: '404',
    hideInMenu: true,
    component: NotFound
  }
]